export const OPINIONS: { name: string; position: string; location: string; review: string }[] = [
  {
    name: 'Gosia z Wrocławia',
    position: '',
    location: '',
    review: `
        Szkolenie z zarządzania wielopokoleniowością otworzyło mi oczy na wiele aspektów, o których wcześniej nie myślałam. Zrozumiałam, jak różne potrzeby i motywacje mają ludzie z różnych pokoleń, i jak skutecznie komunikować się z każdym z nich. Praktyczne ćwiczenia pomogły mi przećwiczyć nowe umiejętności. Teraz czuję się znacznie pewniej w roli lidera zarządzającego zespołem składającym się z osób w różnym wieku.
        `,
  },
  {
    name: 'Ania z Płocka',
    position: '',
    location: '',
    review: `
          Szkolenie z zarządzania wielopokoleniowością otworzyło mi oczy na wiele aspektów, o których wcześniej nie myślałam. Zrozumiałam, jak różne potrzeby i motywacje mają ludzie z różnych pokoleń, i jak skutecznie komunikować się z każdym z nich. Praktyczne ćwiczenia pomogły mi przećwiczyć nowe umiejętności. Teraz czuję się znacznie pewniej w roli lidera zarządzającego zespołem składającym się z osób w różnym wieku.

        `,
  },
  {
    name: 'Kasia z Lublina ',
    position: '',
    location: '',
    review: `
            Dzięki szkoleniu z social mediów od L'Oréal nauczyłam się, jak robić profesjonalne zdjęcia moich koloryzacji. Teraz mój Instagram wygląda dużo lepiej, a klientki same pytają o konkretne stylizacje, które widziały na moim profilu!
        `,
  },
  {
    name: 'Piotr z Warszawy ',
    position: '',
    location: '',
    review: `
        Szkolenia Redken z Sandrą to prawdziwa inspiracja! Sandra to nie tylko świetna stylistka, ale też wspaniała edukatorka. Potrafi przekazać wiedzę w sposób jasny i przystępny, a jej entuzjazm udziela się wszystkim uczestnikom. Szczególnie cenne są jej wskazówki dotyczące pracy technikami z wolnej ręki, dzięki którym można osiągnąć najmodniejsze efekty. Całe szkolenie przesiąknięte jest nowoczesnym, hollywoodzkim vibe'm i energią charakterystyczną dla marki Redken. To prawdziwy zastrzyk inspiracji i motywacji!
        `,
  },
  {
    name: 'Kasia z Warszawy',
    position: '',
    location: '',
    review: `
        Szkolenie Kérastase to była prawdziwa uczta dla każdego fryzjera! Dogłębna wiedza o produktach, ich składach i działaniu, pokazana w bardzo przystępny sposób. W końcu rozumiem, jak dobierać idealne produkty do potrzeb moich klientek i jak osiągać spektakularne efekty. Duży plus za praktyczne ćwiczenia i możliwość testowania produktów. Czuję się znacznie pewniej w rekomendowaniu pielęgnacji.
        `,
  },
];
